import { Pipe, PipeTransform, inject } from "@angular/core";
import { AuthKey, I18nService } from "./i18n.service";

/**
 * `{{ 'login.title' | t }}` en las plantillas de auth.
 *
 * Impuro a propósito: la clave que recibe nunca cambia (es un literal), así que
 * un pipe puro cachearía la primera traducción y el texto se quedaría congelado
 * al cambiar de idioma. Es el mismo motivo por el que las librerías de i18n
 * declaran su pipe impuro. El coste es una búsqueda en un objeto por binding y
 * ciclo, nada frente al render del formulario.
 *
 * Leer el signal dentro de `transform` también registra la vista como
 * consumidora, y eso es lo que marca como sucios los componentes OnPush
 * (registro, modal legal) cuando se cambia el idioma.
 */
@Pipe({ name: 't', standalone: true, pure: false })
export class TranslatePipe implements PipeTransform {

  private readonly i18n = inject(I18nService);

  transform(key: AuthKey, params?: Record<string, string>): string {
    this.i18n.lang();
    return this.i18n.t(key, params);
  }
}
